<template>
  <div class="navigation container pos-rel">
    <div class="h-x2" />
    <div class="f-sb f-ac">
      <div class="nav-left f-ac fc-g1 w-0">
        <div
          v-if="showSidebar"
          id="sidebar-toggle"
          class="link m-rx2"
          @click="() => emit('openSidebar')"
        >
          <i class="mi">menu</i>
        </div>
      </div>
      <div class="nav-right f-ac f-je fc-g1 w-0">
        <template v-if="state.currentUser.super_admin">
          <a class="button restricted inv f-ac m-r" href="/onboarding/preset_categories">
            <cdn-svg class="h-x3 w-x3" path="nucleo/books" />
            <div class="t m-l">Building&nbsp;Blocks</div>
          </a>s
          <a class="button restricted inv f-ac m-r" href="/teams">
            <cdn-svg class="h-x3 w-x3" path="nucleo/building" />
            <div class="t m-l">Teams</div>
          </a>
          <a class="button restricted inv f-ac m-rx2" href="/admin">
            <cdn-svg class="h-x3 w-x3" path="nucleo/lock" />
            <div class="t m-l">Admin</div>
          </a>
        </template>
        <a class="link m-rx2" href="https://help.donut.ai" target="_blank"><i class="mi">live_help</i></a>
        <div class="pos-rel">
          <div class="avatar avatar-md c-p" @click.stop="onAvatarClick"><img :src="state.currentUser.avatar"></div>
          <div v-if="userDropdownOpen" ref="userDropdown" class="dropdown w-x18 top-32 right-0">
            <div class="p-lx2 p-rx3 p-v">
              <div class="t bold">{{ state.currentUser.name }}</div>
              <div class="t dark-gray m-t2">{{ state.currentTeam.name }}</div>
            </div>
            <div class="separator m-v" />
            <a class="link" :href="`/users/${state.currentUser.id}/profile`">My Profile</a>
            <a class="link" href="/users/integrations">My Integrations</a>
            <div class="separator m-v" />
            <donut-form ref="signOutForm" method="delete" action="/users/sign_out">
              <a class="link" @click="signOut">
                <i class="mi md-18">vpn_key</i>
                <div class="t m-l">Sign out</div>
              </a>
            </donut-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const props = defineProps({
    showSidebar: { type: Boolean, required: true },
  });
  const emit = defineEmits(['openSidebar']);

  // User Dropdown Opening/Closing
  const userDropdown = ref(null);
  const userDropdownOpen = ref(false);
  const onWindowClick = (event) => {
    if (userDropdown.value && userDropdown.value.contains(event.target)) return;
    userDropdownOpen.value = false;
  };
  const onAvatarClick = () => { userDropdownOpen.value = !userDropdownOpen.value; };

  // Signing Out Functionality
  const signOutForm = ref(null);
  const signOut = () => { signOutForm.value.submit(); };

  // Lifecycle hooks
  onMounted(() => {
    window.addEventListener('click', onWindowClick);
  });
  onUnmounted(() => {
    window.removeEventListener('click', onWindowClick);
  });
</script>
